module.exports = __webpack_public_path__ + "static/img/year-in-review-lores.a911da4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/year-in-review-lores.jpg
// module id = q76p
// module chunks = 0